const components = new Map()

components.set('media.logo', ctx => ({
  component: 'MediaComponent',
  key: 'media.logo',
  defaultPlacement: 'presentation',
  props: {
    label: ctx.labels['logo'],
    placement: 'inside',
    size: 'contain',
    style: 'height: 200px;',
    uploadOptions: { compression: 'logo' },
    description: false,
  },
}))

components.set('media.logoInverted', ctx => ({
  key: 'media.logoInverted',
  defaultPlacement: 'presentation',
  component: 'MediaComponent',
  props: {
    label: ctx.labels['logoInverted'],
    placement: 'inside',
    size: 'contain',
    style: 'height: 200px;',
    uploadOptions: { compression: 'logo' },
    description: false,
  },
}))

components.set('media.favicon', ctx => ({
  key: 'media.favicon',
  defaultPlacement: 'presentation',
  component: 'MediaComponent',
  props: {
    label: ctx.labels.favicon,
    placement: 'inside',
    size: 'contain',
    style: 'height: 200px;',
    uploadOptions: { compression: { maxWidth: 200 } },
    description: false,
  },
}))

components.set('themeColor', ctx => ({
  key: 'theme.primary',
  defaultPlacement: 'theme',
  component: 'ColorSelector',
  props: {
    label: ctx.$t('primaryColor'),
    'data-field': 'themeColor',
  },
}))

components.set('themeColorSecondary', ctx => ({
  key: 'theme.secondary',
  defaultPlacement: 'theme',
  component: 'ColorSelector',
  props: {
    label: ctx.$t('secondaryColor'),
    'data-field': 'themeColorSecondary',
  },
}))

export default components
